module.exports = __webpack_public_path__ + "img/computer3.7a30408c.gif";